import React from 'react';

// Gold triangular A / peak mark — inspired by the Aurelian Heights logo
const LogoMark = ({ size = 44, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <defs>
      <linearGradient id="ahGold" x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#D4B684" />
        <stop offset="0.55" stopColor="#BFA070" />
        <stop offset="1" stopColor="#A88754" />
      </linearGradient>
    </defs>
    {/* Outer A peak */}
    <path
      d="M32 5 L60 58 L52 58 L32 19 L12 58 L4 58 Z"
      fill="url(#ahGold)"
    />
    {/* Inner mirrored / offset peak creating the AH negative space */}
    <path
      d="M32 18 L46 46 L40 46 L32 30 L24 46 L18 46 Z"
      fill="url(#ahGold)"
      opacity="0.9"
    />
    {/* Subtle crossbar hinting at H */}
    <path d="M22 40 L42 40" stroke="url(#ahGold)" strokeWidth="2.2" strokeLinecap="square" />
  </svg>
);

export default LogoMark;
